<template>
  <div id="app">
    <bsi-navigation />

    <b-container class="mt-4">
      <router-view />
    </b-container>

    <bsi-footer></bsi-footer>

    <vue-progress-bar />
    <cookie-consent v-if="branch == 'swim'" />
  </div>
</template>

<script>
import BsiFooter from '@/modules/navigation/components/BsiFooter'
import BsiNavigation from '@/modules/navigation/components/BsiNavigation'
import CookieConsent from '@/modules/cookie/components/CookieConsent'
import * as types from '@/types'
import moment from 'moment'

export default {
  name: 'App',
  components: {
    BsiFooter,
    BsiNavigation,
    CookieConsent
  },
  data() {
    return {
      branch: process.env.VUE_APP_BRANCH
    }
  },
  computed: {
    entries() {
      return this.$store.state.cart.cart.entries
    }
  },
  mounted() {
    if (!this.entries.length) {
      this.$store.commit(types.RESET_CART_TIMEOUT)
      return
    }

    const now = moment()
    const expiredEntries = this.entries.filter(e => !e.expiresAt || now.isAfter(e.expiresAt))

    if (expiredEntries.length === this.entries.length) {
      this.$store.commit(types.EMPTY_CART)
      this.$store.commit(types.RESET_CART_TIMEOUT)
    } else if (expiredEntries.length > 0) {
      this.$store.dispatch(types.REMOVE_EXPIRED_ENTRIES_FROM_CART)
    }
  }
}
</script>

<style lang="scss">
html {
  &.show-nav {
    overflow: hidden;
  }
}

body {
  color: $grey-blue;
  font-family: Montserrat, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

  &.show-nav {
    overflow: hidden;
  }
}

.nav-item {
  &:hover {
    text-decoration: underline;
  }
}

.page-header {
  font-size: 32px;
  font-weight: $font-weight-medium;
  letter-spacing: 0.8px;
}
</style>
